import { DEFAULT_TIMEZONE } from 'Data/constants.js'
import { formatTzDate } from 'Data/format.js'
import { utcToZonedTime } from 'date-fns-tz'

export function formatTimestamp(value, time_zone_id) {
  return formatTzDate(
    utcToZonedTime(`${value}Z`, time_zone_id || DEFAULT_TIMEZONE),
    'M/dd/y h:mm b',
    time_zone_id || DEFAULT_TIMEZONE
  )
}

export function formatCreator(creator) {
  return creator?.person
    ? `by ${creator.person.first_name} ${creator.person.last_name}`
    : ''
}

export function formatEditor(note) {
  let { creator, editor } = note
  return !editor || creator?.person?.id === editor?.person?.id
    ? ''
    : `Last edit by ${editor.person?.first_name} ${editor.person?.last_name}`
}
